import { jsxs, jsx } from "react/jsx-runtime";
import { useClassNameFactory } from "@contember/react-utils";
import { XIcon } from "lucide-react";
import { memo } from "react";
import { toFeatureClass } from "../../utils/toFeatureClass.js";
import { toEnumViewClass } from "../../utils/toEnumViewClass.js";
import { Stack } from "../Stack/Stack.js";
import { Button } from "../Forms/Button/Button.js";
const DialogModal = memo(({
  bodyClassName,
  bodyProps,
  children,
  className,
  dividers = false,
  footer,
  footerClassName,
  footerProps,
  header,
  headerClassName,
  headerProps,
  layout = "fit-content",
  onClose,
  ...rest
}) => {
  const componentClassName = useClassNameFactory("dialog-modal");
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ...rest,
      className: componentClassName(null, [
        toFeatureClass("dividers", dividers),
        toEnumViewClass(layout),
        className
      ]),
      children: [
        /* @__PURE__ */ jsxs(
          Stack,
          {
            ...headerProps,
            align: headerProps?.align ?? "center",
            horizontal: headerProps?.horizontal ?? true,
            justify: headerProps?.justify ?? "space-between",
            className: componentClassName("header", headerClassName),
            children: [
              header,
              /* @__PURE__ */ jsx(Button, { square: true, borderRadius: "full", onClick: onClose, distinction: "seamless", className: componentClassName("close-button"), children: /* @__PURE__ */ jsx(XIcon, {}) })
            ]
          }
        ),
        children && /* @__PURE__ */ jsx("div", { className: componentClassName("body-wrapper"), children: /* @__PURE__ */ jsx(
          Stack,
          {
            ...bodyProps,
            className: componentClassName("body", bodyClassName),
            children
          }
        ) }),
        footer && /* @__PURE__ */ jsx(
          Stack,
          {
            ...footerProps,
            className: componentClassName("footer", footerClassName),
            horizontal: footerProps?.horizontal ?? true,
            justify: footerProps?.justify ?? "end",
            children: footer
          }
        )
      ]
    }
  );
});
DialogModal.displayName = "DialogModal";
export {
  DialogModal
};
//# sourceMappingURL=DialogModal.js.map
